import utils from 'utils';

import {useEffect, useRef, useState} from 'react';

import {DetailAdditionalPayment, DetailNote, UiButton, UiCheckbox, UiTextInput} from '@components/export';
import {useLabel} from '@/hooks/export';

import {InputAdornment} from '@mui/material';

export const DetailLinesOrderItem = (props: {
    line: apiOrderLine,
    locked: boolean,
    additionalPaymentList: apiOrderLine[],

    onLineUpdate: (field: string, value: any) => void,
    onAdditionalPaymentAdd: (lineId: string, paymentId: string) => void,
}) => {
    const label = useLabel();

    // fixme: duplicate from DetailLinesProductItem
    // fixme: please, refactor it

    const timeoutRef = useRef(null);

    const [price, setPrice] = useState(props.line.price.toString().replace('.', ','));
    const priceRef = useRef(props.line.price.toString().replace('.', ','));

    const handle = {
        delayPriceUpdate(value: string) {
            if (!value.match('^([0-9,.]+)$')) {
                return;
            }

            priceRef.current = parseFloat(value.replace(',', '.')).toFixed(2);
            setPrice(value);

            if (!value || !value.match('^([0-9]+)(,?)([0-9]{0,2})$')) {
                return;
            }

            utils.doWithTimeout(() => {
                setPrice(priceRef.current);
                props.onLineUpdate('price', priceRef.current);
            }, 5000, timeoutRef);
        },
        doPriceUpdate() {
            props.onLineUpdate('price', parseFloat(priceRef.current.replace(',', '.')).toFixed(2));
        },
    };

    useEffect(() => {
        priceRef.current = parseFloat(props.line.price.toString()).toFixed(2).replace('.', ',');
        setPrice(parseFloat(props.line.price.toString()).toFixed(2).replace('.', ','));
    }, [props.line.price]);

    return <div className={
        classMap.item +
        (props.line.parentId ? ' ' + classMap.itemChild : '')
    }>
        <div className={classMap.itemCell}>
            {props.line.itemCode}
        </div>
        <div className={classMap.itemCell}>
            <div>
                {
                    props.line.parentId ?
                        <i className={'iconfas-arrowTopToBottomRight'}></i> :
                        <></>
                }
                {props.line.name}
            </div>
            {
                props.line.note ?
                    <div className={classMap.itemCellNote}>
                        <span><i className={'iconfa-note'}></i>:</span>
                        <span>{props.line.note}</span>
                    </div> : <></>
            }
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            {props.line.qty + ' ' + label.qty}
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            <UiTextInput
                value={price}
                endAdornment={<InputAdornment position="end">{label.currency}</InputAdornment>}
                sx={{
                    padding: 0.5,
                    width: 120,
                    alignItems: 'baseline',
                    input: {textAlign: 'right', padding: 0, fontWeight: 500},
                }}
                size={'small'}
                inputMode={'decimal'}
                onFocus={(e) => e.target.select()}
                onBlur={() => {
                    clearTimeout(timeoutRef.current);
                    handle.doPriceUpdate();
                }}
                onChange={(e) => handle.delayPriceUpdate(e.target.value || '0')}
                disabled={props.locked}
            />
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            {(props.line.price * props.line.qty).toFixed(2).replace('.', ',') + ' ' + label.currency}
        </div>

        <div className={classMap.itemCell + (props.locked ? ' ' + classMap.itemCellDisabled : '')}>
            {
                !props.line.deletable ?
                    <DetailAdditionalPayment
                        additionalPaymentList={props.additionalPaymentList}
                        locked={props.locked}

                        onAdditionalPaymentAdd={(paymentId) => props.onAdditionalPaymentAdd(props.line.id, paymentId)}
                    /> : <></>
            }
            <DetailNote
                note={props.line.note}
                disabled={props.locked}
                popupOrigin={{
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: -5,
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                }}
                hideLabel

                onUpdate={(value) => props.onLineUpdate('note', value)}
            />
            {
                !props.line.deletable ?

                    <div className={
                        classMap.itemCellCheckbox +
                        (props.line.isDone ? ' ' + classMap.itemCellCheckboxActive : '') +
                        (props.locked ? ' ' + classMap.itemCellCheckboxDisabled : '')
                    }>
                        <UiCheckbox
                            onChange={(checked) => props.onLineUpdate('isDone', checked)}
                            checked={props.line.isDone}
                            disabled={props.locked}
                        />
                    </div> :
                    <UiButton
                        style={5}
                        text={''}
                        icon={'iconfa-trash'}
                        onClick={() => props.onLineUpdate('deleted', true)}
                        disabled={props.locked}
                    />
            }
        </div>
    </div>;
};

const cmpClass = 'detail-lines';
const classMap = utils.generateClassMap(cmpClass, {
    item: 'item',
    itemChild: 'item--child',
    itemCell: 'item-cell',
    itemCellCheckbox: 'item-cell-checkbox',
    itemCellCheckboxActive: 'item-cell-checkbox--active',
    itemCellCheckboxDisabled: 'item-cell-checkbox--disabled',
    itemCellDisabled: 'item-cell--disabled',
    itemCellRight: 'item-cell--right',
    itemCellNote: 'item-cell-note',
});
